export enum SortBy
{
    Name = "Name",
    Role = 'Role',
    Phone= "",
    City = "City",
    Reg = "RequestType",
    BroughtFrom = "BroughtFrom",
    ReceivedBy = "ReceivedBy",
    Office = 'Office',
    Floor= "Floor",
    Gate = "Gate",
    Status = 'Status',
    IsActive='IsActive',
    CheckIn = 'CheckIn' ,
    CheckOut = 'CheckOut' ,
    Mode='Mode',
    ChangedAttribute = 'ChangedAttribute',
    BadgeStatus='BadgeStatus',
    EmployeeType='EmmployeeType',
    Agency = 'Agency',     
    Designation = 'Designation',
    RequestName='Request Name',
    RequestType='Request Type',
    Stage='Stage',
    RequestDate='Request Date',
    DueDate='Due Date',
    ChangedBy='ChangeBy',
    RequestedBy='FirstName',
    ActionPerformed="ActionPerformed"

}
